import { useEffect } from 'react'

type Props = {
  sectionRef: React.RefObject<HTMLDivElement>
  onFocusOut: (e: FocusEvent) => void
}

export const useFocusOutListener = ({ sectionRef, onFocusOut }: Props) => {
  useEffect(() => {
    if (!sectionRef.current) return
    const handleFocusOut = async (e: FocusEvent) => {
      onFocusOut(e)
    }

    const node = sectionRef.current
    if (node) {
      node.addEventListener('focusout', handleFocusOut, true)
    }

    return () => {
      if (node) {
        node.removeEventListener('focusout', handleFocusOut, true)
      }
    }
  }, [sectionRef.current])
}
